import { createContext } from 'react';

/**
 * Unique identifier for a request
 */
export type RequestId = string;
export interface RequestContext {
  /**
   * Indicates whether the current request is active or not
   * @example
   * When the current request is in flight and could be dangerous if the user re-triggers it
   * See Admin Console's `hasUnsafeToCacheNetworkRequest`
   */
  isRequestActive: (request: RequestId) => boolean;
  /**
   * Called when a request is first requested
   */
  onRequestStart: (request: RequestId) => void;
  /**
   * Called after a request has resolved or has thrown an error
   */
  onRequestEnd: (request: RequestId, err?: Error) => void;
}

export default (() => {
  const set = new Set<RequestId>();

  return createContext({
    isRequestActive(request) {
      return set.has(request);
    },
    onRequestStart(request) {
      set.add(request);
    },
    onRequestEnd(request) {
      set.delete(request);
    }
  } as RequestContext);
})();
